import React, { useEffect } from "react";
import StickySearch from "../../../common/search/sticky-search";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

const TopBar = (props) => {
	const {
		push,
		location,
		reset,
		clearFilters,
		setFilteredItem,
		categoriesFilter,
		getInventory,
		filteredItems,
		tenantPhone,
		content,
	} = props;

	useEffect(() => {
		var closemyslide = document.getElementById("mySidenav");
		closemyslide && closemyslide.classList.remove("open-side");
	}, [location]);

	return (
		<div className="top-header d-sm-none d-md-none d-lg-none d-xl-block">
			<div className="container">
				<div className="row">
					<div className="col-lg-2">
						<div className="header-contact">
							<ul>
								<li>
									<i className="fa fa-phone" aria-hidden="true"></i>
									{tenantPhone}
								</li>
							</ul>
						</div>
					</div>
					<div className="col-md-12 col-lg-10 col-xl-10">
						<ul className="offset-xl-1 header-dropdown">
							<li>
								<StickySearch
									{...{
										push,
										reset,
										location,
										clearFilters,
										setFilteredItem,
										categoriesFilter,
										getInventory,
										filteredItems,
									}}
								/>
							</li>
							{content &&
								content.links
									.filter((x) => x.header !== 0)
									.sort((a, b) => (a.sequence > b.sequence ? 1 : -1))
									.map((x) => (
										<li key={x.key}>
											<Link to={`/content?${x.key}`}>{x.value}</Link>
										</li>
									))}
							<li>
								<Link to="/info-center">Information</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	content: state.authorization.content,
});

export default connect(mapStateToProps)(TopBar);
